import Auth from './Auth.vue';
import Verify from './Verify.vue';

export default {
    install: (app, options) => {
        [
            Auth,
            Verify
        ].forEach(Component => {
            app.component(Component.name, Component);
        });
    }
}